<template>
  <div class="wrap">
    <div class="logo">
      <img src="@/assets/new/login/logo.png" alt="">
    </div>
    <div class="top_title">
      <div class="title3">{{ $t('login.title') }}</div>
    </div>
    <div class="form_bar">
      <div class="inputs">
        <div v-for="(item, index) in formList" :key="index" class="input_item">
          <div class="_item">
            <img :src="item.icon" alt="">
            <input :type="item.type" :placeholder="$t(item.placeholder)" :maxlength="item.length"
              v-model="form[item.key]" :adjust-position="true" />
            <i class="iconfont pwd_icons" v-if="item.key === 'password'"
              :class="item.flag === true ? 'icon-yanjing' : 'icon-yanjing-bi'" @click="handleLookPass"></i>
          </div>
        </div>
      </div>
      <div class="btn_login" @click="handleLogin">{{ $t("login.title") }}</div>
      <div class="tips">
        <div class="tips_title">{{ $t('login.dontAccount') }}</div>
        <div class="tips_btn" @click="toRegister">{{ $t('注册') }}</div>
      </div>
    </div>
    <div class="lan_bar" v-if="verConfig.loginSetLans" @click.stop="switchLansShow = true">
      <img src="../../assets/mine/lang.png" alt="">
    </div>
    <van-action-sheet v-model="switchLansShow" :actions="lans" :cancel-text="$t('user.Button.One')"
    :description="$t('切换语言')" close-on-click-action @select="checkLans" />
    <LoadingRE :show="LoadingShow" />
  </div>
</template>

<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  GridItem,
  Grid,
  NavBar,
  ActionSheet,
  Button,
  Toast,
  Checkbox,
  CheckboxGroup,
  Dialog,
} from "vant";

// 设置vant的多语言
import md5 from "js-md5";
import Cookies from "js-cookie";
import { Locale } from "vant";
import enUS from "vant/lib/locale/lang/en-US";
import Modelu from "@/utils/Module";
import { getNewPhone } from "@/utils/tools";
import { mapGetters } from "vuex";

import { REQUEST_API, REQUEST_API2, REQUEST_API3 } from "@/http/api";
import { LOGIN } from "@/api";
import LoadingRE from "@/components/LoadingRE";
import AreaCodePicker from "@/components/areaCodePicker";
import LoginType from "@/components/newLoginType";
import SetLans from "@/components/setLans";
import verConfig from "@/utils/verConfig";
import i18n from "@/i18n";
import { getLanguage, setLan, setLanguage, lans } from "../../i18n";

const phoneItem = {
  placeholder: `${i18n.t("Login.nameInput")}`,
  icon: "icon-wode",
  type: "tel",
  key: "userName",
  length: 11,
};
const emailItem = {
  placeholder: `${i18n.t("Login.emailInput")}`,
  icon: "icon-wode",
  type: "text",
  key: "userName",
  length: 99,
  onlyEmeil: true,
};

const _currentLoginType = () => {
  if (verConfig.onlyEmailLogin) {
    return "email";
  }
  return "phone";
};

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [NavBar.name]: NavBar,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    LoadingRE,
    AreaCodePicker,
    LoginType,
    SetLans,
  },
  data() {
    return {
      loginType: 'phone',
      newLoginType: 'email',
      LoadingShow: false,
      areaCode: "",
      message: "copy",
      country: Cookies.get("language"),
      form: {
        userName: "",
        password: "",
      },
      formList: [{
        placeholder: 'login.phoneNumber',
        icon: require("@/assets/new/login/phone.png"),
        key: "userName",
        type: "tel",
        length: 11,
      }, {
        placeholder: 'login.password',
        icon: require("@/assets/new/login/pwd.png"),
        key: "password",
        type: "password",
        length: 99,
        flag: false,
      }],
      tablelist: [
        // {
        //   label: `${this.$t('Login.forgot')}`,
        //   key: 'forgot',
        // },
        {
          label: `${this.$t("Login.registrasi")}`,
          key: "registrasi",
        },
      ],
      checked: false,
      thePwdObj: {
        userName: "",
        passwordL: "",
      },
      show: false,
      userAgreementChecked: true,
      switchLansShow: false,
      lans:lans
    };
  },
  created() {
    this.init();
  },
  methods: {
    checkLans(actions, index) {
      if (actions.value === getLanguage()) {
        this.switchLansShow = false;
        return;
      }
      this.$i18n.Locale = actions.value;
      this.changeLanguage(actions.value);
      setLanguage(actions.value);
    },
    toService() {
      this.$api.toService();
    },
    toRegister() {
      this.$router.push('/registrasi')
    },
    handleLookPass() {
      if (this.formList[1].type === "password") {
        this.formList[1].type = "text";
        this.formList[1].flag = true;
      } else {
        this.formList[1].type = "password";
        this.formList[1].flag = false;
      }
    },
    handleLogin() {
      if (!this.form.userName) return Toast(this.$t('login.phoneNumberPlaceholder'));
      if (!this.form.password) return Toast(this.$t('login.passwordPlaceholder'));
      this.login();

    },
    login() {
      let form = {
        userphone: this.form.userName,
        userpass: this.form.password,
        country_code: this.areaCode,
      };
      const emailReg =
        /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,})$/;
      if (this.loginType === "email") {
        form.userphone = this.form.userName;
        form.country_code = "";
        if (!emailReg.test(form.userphone)) {
          Toast(this.$t("emailFormatError"));
          return;
        }
      }
      this.$store.dispatch("login", form).then((res) => { });
    },
    init() {
      let storePwdState = localStorage.getItem("the-pwd-state");
      let storePwd = localStorage.getItem("the-pwd-obj");
      this.$cookie.clear();
      this.$cookie.set("the-pwd-state", storePwdState);
      this.$cookie.set("the-pwd-obj", storePwd);
      let initObj = {
        userName: "",
        passwordL: "",
      };
      this.checked =
        storePwdState && storePwdState !== "undefined"
          ? JSON.parse(storePwdState)
          : false;
      this.form = storePwd
        ? JSON.parse(storePwd)
          ? JSON.parse(storePwd)
          : initObj
        : initObj;
    },
  },
  computed: {
    ...mapGetters(["theme"]),
  },
};
</script>

<style lang="less" scoped>
@checkbox-label-color: #88888d;
@Color: var(--theme);
@background: var(--bg);
@bg: var(--bg);
@sizeColor: var(--sizeColor);
@newbgColor: #272a29;

.wrap {
  min-height: calc(100vh - 40rem / 16);
  padding: calc(20rem / 16) calc(10rem / 16);
  background: var(--bgImg) no-repeat;
  background-size: cover;

  .logo {
    width: 50%;
    margin: 10px auto 0;

    img {
      width: 100%;
      display: block;
    }
  }

  .top_title {
    margin-top: calc(-10rem / 16);
    padding-bottom: calc(15rem / 16);

    .title3 {
      font-size: calc(42rem / 16);
      color: var(--white);
      font-weight: 700;
      text-align: center;
      text-shadow: 5px 5px 8px #030913;
    }
  }

  .form_bar {
    padding: 0 calc(15rem / 16);

    .inputs {
      .input_item {
        margin: calc(15rem / 16) 0 0;
        padding: 0;

        ._item {
          border-radius: 5px;
          background-color: var(--white);
          padding: 0 calc(10rem / 16);
          display: flex;
          align-items: center;
          img{
            width: 24px;
          }

          input {
            flex: 1;
            border: 0;
            padding: 0;
            padding-left: calc(10rem / 16);
            font-size: calc(14rem / 16);
            height: calc(48rem / 16);
            line-height: calc(48rem / 16);
            background-color: transparent;
            color: @Color;
          }

          input:placeholder {
            font-size: calc(14rem / 16);
            color: var(--inputPlaceholder);
          }
        }
      }
    }

    .btn_login {
      margin: calc(35rem / 16) 0 calc(10rem / 16);
      background: var(--newbtnColor);
      color: var(--btnsizeColor);
      border-radius: calc(8rem / 16);
      height: calc(60rem / 16);
      font-size: calc(16rem / 16);
      text-align: center;
      line-height: calc(60rem / 16);
      font-weight: bold;
    }

    .tips {
      margin-top: calc(20rem / 16);
      font-size: calc(14rem / 16);
      color: var(--white);
      text-align: center;
      display: flex;
      align-items: baseline;
      justify-content: center;

      &_title {
        margin-bottom: calc(10rem / 16);
      }

      &_btn {
        text-decoration: underline;
        font-weight: 700;
        font-size: calc(20rem / 16);
      }
    }
  }

  .lan_bar {
    position: absolute;
    top: 6px;
    right: 6px;
    img{
      width: 30px;
      height: 30px;
    }
  }
}
</style>
